import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

const tokenHeader = () => {
  const token = localStorage.getItem('nl_admin_token');
  return token ? { 'X-Admin-Token': token } : {};
};

export const getProducts = (params = {}) => client.get('/products', { params }).then(r => r.data);
export const getProduct = (id) => client.get(`/products/${id}`).then(r => r.data);
export const getCategories = () => client.get('/categories').then(r => r.data);
export const getSettings = () => client.get('/settings').then(r => r.data);
export const createOrder = (data) => client.post('/orders', data).then(r => r.data);
export const createContact = (data) => client.post('/contact', data).then(r => r.data);
export const getContacts = () => client.get('/contact', { headers: tokenHeader() }).then(r => r.data);
export const deleteContact = (id) => client.delete(`/contact/${id}`, { headers: tokenHeader() }).then(r => r.data);

// admin
export const adminLogin = (password) => client.post('/admin/login', { password }).then(r => r.data);
export const createProduct = (data) => client.post('/products', data, { headers: tokenHeader() }).then(r => r.data);
export const updateProduct = (id, data) => client.put(`/products/${id}`, data, { headers: tokenHeader() }).then(r => r.data);
export const deleteProduct = (id) => client.delete(`/products/${id}`, { headers: tokenHeader() }).then(r => r.data);
export const getOrders = () => client.get('/orders', { headers: tokenHeader() }).then(r => r.data);
export const updateOrderStatus = (id, status) => client.put(`/orders/${id}/status`, null, { params: { status }, headers: tokenHeader() }).then(r => r.data);
export const deleteOrder = (id) => client.delete(`/orders/${id}`, { headers: tokenHeader() }).then(r => r.data);
export const getStats = () => client.get('/admin/stats', { headers: tokenHeader() }).then(r => r.data);
export const updateSettings = (data) => client.put('/settings', data, { headers: tokenHeader() }).then(r => r.data);

export default client;
